import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { PopularTitlesSorting, TitleFilter } from '@/@types/graphql-types';
import { CollectionType } from '@/enums/collection-type';
import ProfileBlock from '@/features/user-profile/components/ProfileBlock.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import PosterGraphql from '@/components/poster/PosterGraphql.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';
import { useQuery } from '@/helpers/composables/useApollo';
import { useFilterStore, useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { toGraphqlFilters } from '@/helpers/graphql-model-helper';
import {
	GetSearchTitlesDocument,
	GetSearchTitlesQuery,
	GetSearchTitlesQueryVariables,
} from '@/pages/graphql/queries/GetSearchTitles.query';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTitlesPreview',
  props: {
    personContentId: null
  },
  setup(__props: any) {

const props = __props as { personContentId: string };

const { isLoggedIn } = useUserStore();
const { setView } = useUserProfile();
const { language, country } = useLanguageStore();
const { filters, selectedProviders } = useFilterStore();



const isFiltersVisible = ref(false);

const filtersSearch = computed(() => filters.value(CollectionType.SEARCH));

const graphqlFilters = computed<TitleFilter>(() =>
	toGraphqlFilters(filtersSearch.value, selectedProviders.value(!isLoggedIn.value))
);

const personId = computed(() => (props.personContentId ? `tp${props.personContentId}` : null));

const queryVariables = computed<GetSearchTitlesQueryVariables>(() => ({
	searchAfterCursor: '',
	searchTitlesFilter: {
		...(isFiltersVisible.value || isLoggedIn.value ? graphqlFilters.value : {}),
		personId: personId.value ?? null,
		includeTitlesWithoutUrl: true,
	},
	first: 20,
	searchTitlesSortBy: PopularTitlesSorting.Popular,
	language: language.value,
	country: country.value,
	location: 'UserTitlePreviews',
}));

const { result: searchPageData } = useQuery<GetSearchTitlesQuery, GetSearchTitlesQueryVariables>(
	GetSearchTitlesDocument,
	queryVariables
);

const searchTitles = computed(() => searchPageData.value?.searchTitles.edges ?? []);

const titleAmount = computed(() => searchPageData.value?.searchTitles.totalCount ?? 0);

return { __sfc: true,isLoggedIn, setView, language, country, filters, selectedProviders, props, isFiltersVisible, filtersSearch, graphqlFilters, personId, queryVariables, searchPageData, searchTitles, titleAmount, ProfileBlock, HiddenHorizontalScrollbar, PosterGraphql }
}

})